<template>
  <v-card
    class="mx-auto"
    max-width="650"
    min-width="300"
  >
    <v-list-item two-line>

    	<!-- Avatar -->
      <v-list-item-avatar
        size="60"
        rounded
      >
      	<v-img :src="photo"></v-img>
  		</v-list-item-avatar>

  		<!-- Content -->
      <v-list-item-content>
        <v-list-item-title class="headline mb-1">{{title}}</v-list-item-title>
        <v-text-field
        	class="pl-1 pr-1"
        	dense
          hide-details
          solo-inverted
          @mouseover="selectLink"
          :value="link"
        ></v-text-field>
      </v-list-item-content>

      <!-- Actions -->
     	<v-list-item-action>

     		<!-- Delete -->
        <v-tooltip left>
        	<template v-slot:activator="{ on, attrs }">
	        <v-btn
		        v-bind="attrs"
	          v-on="on" 
	          icon
	          @click="wannaDelete"
	        >
	          <v-icon>far fa-trash-alt</v-icon>
	        </v-btn>
	         </template>
      		<span>{{ $t("prvScama.links.delete") }}</span>
      	</v-tooltip>

      	<!-- Edit -->
				<v-tooltip left>
     			<template v-slot:activator="{ on, attrs }">
	        	<v-btn 
	        		v-bind="attrs"
		          v-on="on"
		          icon
		          @click="editScama"
		        >
		          <v-icon>fas fa-pen</v-icon>
		        </v-btn>
	        </template>
      		<span>{{ $t("prvScama.links.edit") }}</span>
      	</v-tooltip>
      </v-list-item-action>

    </v-list-item>
  </v-card>
</template>


<script>
export default {
  name: 'linkCard',
  props: {
    id: Number,
    title: String,
    photo: String,
    link: String,
  },
  methods : {
  	selectLink(event){
  		event.target.select();
  	},
  	editScama(){
  		this.$router.push({path : 'edit/'+this.id});
  	},
    wannaDelete(){
      this.$emit('wannaDelete', this.id);
    }
  }
};
</script>
